import React, { useEffect, useState } from "react";
import "./Settings.css";
import apiServiceHandler from "../../service/apiService";
import "toastr/build/toastr.min.css";
import toastr from "toastr";
import { useDispatch } from "react-redux";
import { updateRefreshUserData } from "../../redux/userData";

const Settings = () => {
  const dispatch = useDispatch()
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [contact, setContact] = useState('');
  const [jobTitle, setJobTitle] = useState('');
  const [hobbies, setHobbies] = useState('');
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [refreshCurrentUser, setRefreshCurrentUser] = useState(false);

  const [isEditing, setIsEditing] = useState(false);
  const [originalData, setOriginalData] = useState({});

  const getCurrentUser = async () => {
    try {
      const response = await apiServiceHandler("GET", "api/user/profile", {});
      console.log(response, 'response is here..');
      if (response.success && response.data) {
        setOriginalData(response.data);
        setName(response.data?.name);
        setEmail(response.data?.email);
        setCountryCode(response.data?.country_code);
        setContact(response.data?.contact);
        setJobTitle(response.data?.job_title);
        setHobbies(response.data?.hobbies);
        setImage(response.data?.image);
      }
    } catch (error) {
      console.error("Error getting getCurrentUser:", error);
    }
  };

  useEffect(() => {
    getCurrentUser();
    setRefreshCurrentUser(false);
  }, [refreshCurrentUser]);

  const toggleEditMode = () => {
    setIsEditing(!isEditing);
  };

  const cancelEditMode = () => {
    setCountryCode(originalData.country_code || '');
    setContact(originalData.contact || '');
    setJobTitle(originalData.job_title || '');
    setHobbies(originalData.hobbies || '');
    setImagePreview(originalData.image || null);
    setRefreshCurrentUser(true);
    setIsEditing(!isEditing);
  }

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSaveChanges = async () => {
    try {
      const formData = new FormData();

      if (name != originalData.name) formData.append("name", name);
      if (countryCode != originalData.country_code) formData.append("country_code", countryCode);
      if (contact != originalData.contact) formData.append("contact", contact);
      if (jobTitle != originalData.job_title) formData.append("job_title", jobTitle);
      if (hobbies != originalData.hobbies) formData.append("hobbies", hobbies);
      if (image != originalData.image) formData.append("image", image);

      const response = await apiServiceHandler("PATCH", "api/user/profile", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      // console.log("Profile updated:", response);
      if (response.auth) {
        toastr.success(response.message);
        dispatch(updateRefreshUserData());
        setRefreshCurrentUser(true);
        setIsEditing(!isEditing);
        setImagePreview(null);
      }
    } catch (error) {
      console.error("Error saving changes:", error);
    }
  };

  return (
    <div className="settings-page__content">
      <div className="settings-page-section">
        <div className="settings-page-section__header">
          <div className="settings-page-header">
            <div className="settings-page-header__top">
              <div className="settings-page-header__content">
                <div className="settings-page-header__heading"></div>
              </div>
              <div className="settings-page-header__action">
                {/* Edit Button */}
                {!isEditing && (
                  <button onClick={toggleEditMode} className="edit-btn">
                    Edit
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="settings-page-section__body">
          <div className="tab-container">
            <span className="tab is-active">Account</span>
          </div>

          <div className="account-container">
            <div className="account-avatar">
              {/* Image Section */}
              {/*
              <button className="trash-avatar-btn" disabled={!isEditing}>
                <span className="icon--trash-delete">
                  <svg
                    viewBox="0 0 20 21"
                    fill="#fff"
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon__svg"
                    preserveAspectRatio="xMidYMid meet"
                    style={{ width: "20px", height: "20px" }}
                  >
                    <path
                      fill="#fff"
                      d="M10 0a3.26 3.26 0 00-3.237 3H1.25a.75.75 0 100 1.5h.84l1.691 13.102A2.757 2.757 0 006.51 20h3.307A6.472 6.472 0 018 15.5 6.5 6.5 0 0114.5 9a6.46 6.46 0 012.749.616l.66-5.116h.841a.75.75 0 100-1.5h-5.513A3.26 3.26 0 0010 0zm0 1.5c.89 0 1.605.647 1.726 1.5H8.274c.12-.853.837-1.5 1.726-1.5zm4.5 8.5a5.5 5.5 0 100 11.001A5.5 5.5 0 0014.5 10zm2.5 2.5c.057 0 .113.013.167.032.02.007.037.017.056.027a.49.49 0 01.13.088c.042.04.07.09.093.14.007.013.015.027.02.042.041.11.042.231.002.342-.006.016-.016.031-.024.047a.489.489 0 01-.09.136L15.207 15.5l2.146 2.146c.04.04.066.087.09.134.008.018.018.034.025.052.02.055.032.11.032.168a.502.502 0 01-.032.167c-.007.02-.017.037-.027.056a.49.49 0 01-.087.13.495.495 0 01-.14.093c-.014.007-.028.015-.043.02a.498.498 0 01-.342.002c-.016-.006-.031-.016-.047-.024a.489.489 0 01-.136-.09L14.5 16.207l-2.146 2.146a.493.493 0 01-.134.09c-.018.008-.034.018-.052.025A.497.497 0 0112 18.5a.502.502 0 01-.167-.032c-.02-.007-.037-.017-.056-.027a.49.49 0 01-.13-.087.495.495 0 01-.093-.14c-.007-.014-.015-.028-.02-.043a.498.498 0 01-.002-.342c.006-.016.016-.031.024-.047a.489.489 0 01.09-.136l2.147-2.146-2.146-2.146a.493.493 0 01-.09-.134c-.008-.018-.018-.034-.025-.052A.497.497 0 0111.5 13c0-.057.013-.113.032-.167.007-.02.017-.037.027-.056a.49.49 0 01.088-.13.5.5 0 01.159-.106l.027-.009a.495.495 0 01.146-.028l.034-.002a.497.497 0 01.167.032l.026.014a.491.491 0 01.148.098l2.146 2.147 2.146-2.146a.493.493 0 01.134-.09c.018-.008.034-.018.052-.025A.497.497 0 0117 12.5z"
                    ></path>
                  </svg>
                </span>
              </button>
              */}
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                disabled={!isEditing}
                style={{ display: "none" }}
                id="image-upload"
              />
              <label htmlFor="image-upload">
                <img
                  src={imagePreview || image || "https://st3.depositphotos.com/9998432/13335/v/450/depositphotos_133351928-stock-illustration-default-placeholder-man-and-woman.jpg"}
                  alt="User Avatar"
                  className="account-avatar-image"
                />
              </label>
            </div>

            <div className="account-fields">
              <div className="fields__fieldset">
                {/* Name Field */}
                <div className="fields__field">
                  <div className="field-text-input__label">Name</div>
                  <div className="text-input_input-wrapper">
                    <input
                      type="text"
                      className="field-text-input__input"
                      name="name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      disabled={!isEditing}
                    />
                  </div>
                </div>
                {/* Email Field */}
                <div className="fields__field">
                  <div className="field-text-input__label">Email</div>
                  <div className="text-input_input-wrapper">
                    <input
                      type="email"
                      className="field-text-input__input"
                      name="email"
                      value={email}
                      disabled={true}
                    />
                  </div>
                </div>
              </div>

              {/* Other fields: Country Code, Phone, Job Title, Hobbies */}
              <div className="fields__fieldset">
                <div className="fields__field">
                  <div className="field-text-input__label">Country Code</div>
                  <div className="text-input_input-wrapper">
                    <input
                      type="number"
                      className="field-text-input__input"
                      name="countryCode"
                      value={countryCode}
                      onChange={(e) => setCountryCode(e.target.value)}
                      disabled={!isEditing}
                    />
                  </div>
                </div>
                <div className="fields__field">
                  <div className="field-text-input__label">Phone</div>
                  <div className="text-input_input-wrapper">
                    <input
                      type="number"
                      className="field-text-input__input"
                      name="phone"
                      value={contact}
                      onChange={(e) => setContact(e.target.value)}
                      disabled={!isEditing}
                    />
                  </div>
                </div>
              </div>

              <div className="fields__fieldset">
                <div className="fields__field">
                  <div className="field-text-input__label">Job Title</div>
                  <div className="text-input_input-wrapper">
                    <input
                      type="text"
                      className="field-text-input__input"
                      name="jobTitle"
                      value={jobTitle}
                      onChange={(e) => setJobTitle(e.target.value)}
                      disabled={!isEditing}
                    />
                  </div>
                </div>
                <div className="fields__field">
                  <div className="field-text-input__label">Hobbies</div>
                  <div className="text-input_input-wrapper">
                    <input
                      type="text"
                      className="field-text-input__input"
                      name="hobbies"
                      value={hobbies}
                      onChange={(e) => setHobbies(e.target.value)}
                      disabled={!isEditing}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Save Button */}
            {isEditing && (
              <div className="account-footer">
                <button onClick={cancelEditMode} className="account-cancel-btn">
                  <span className="account-cancel-button__label">Cancel</span>
                </button>
                <button onClick={handleSaveChanges} className="account-save-btn">
                  <span className="icon-home">
                    <svg
                      viewBox="0 0 18 20"
                      fill="#604b51"
                      xmlns="http://www.w3.org/2000/svg"
                      className="icon__svg"
                      preserveAspectRatio="xMidYMid meet"
                      style={{ width: '20px', height: '20px' }}
                    >
                      <path d="M16.75 19.5h-4.5c-.69 0-1.25-.56-1.25-1.25v-4.5a1 1 0 00-1-1H8a1 1 0 00-1 1v4.5c0 .69-.56 1.25-1.25 1.25h-4.5C.56 19.5 0 18.94 0 18.25V8.707C0 7.556.527 6.47 1.43 5.76L8.535.16a.752.752 0 01.928 0l7.107 5.6A3.75 3.75 0 0118 8.706v9.544c0 .69-.56 1.25-1.25 1.25z"></path>
                    </svg>
                  </span>
                  <span className="account-save-button__label">Save</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
